import { listMyAdoptions } from '../api/adoptions';
import { getAnimal, listMyPets } from '../api/animals';

export type AnimalDoc = {
  _id?: string;
  id?: string;
  name?: string;
  species?: string;
  age?: string;
  images?: string[];
  shelter?: string;
  city?: string;
  code?: string;
  lastFeeding?: string;
  lastLitterChange?: string;
  lastWalk?: string;
  mood?: string | null;
  healthHistory?: Array<{
    date?: string;
    type?: string;
    notes?: string;
    vetId?: string;
  }>;
};

export async function fetchFeaturedAnimal(assignedId?: string | null): Promise<AnimalDoc | null> {
  const triedIds = new Set<string>();
  // Doc ya obtenido de /animals/mine o /adoptions/mine: /animals/:id devuelve 404
  // para mascotas personales, así que sin este respaldo se perderían del panel.
  let fallback: AnimalDoc | null = null;

  const enqueue = (value?: string | null) => {
    if (!value) return;
    triedIds.add(String(value));
  };

  enqueue(assignedId);

  const loadDetailed = async (): Promise<AnimalDoc | null> => {
    for (const id of Array.from(triedIds.values())) {
      try {
        const doc = await getAnimal(id);
        if (doc) return doc;
      } catch (error) {
        console.warn('[pet] Error cargando animal asignado', error);
      }
    }
    return null;
  };

  try {
    const myPets = await listMyPets();
    const preferred = assignedId
      ? myPets.items?.find(item => String(item.animal?._id || item.animal?.id) === assignedId)?.animal
      : myPets.items?.[0]?.animal;
    if (preferred) {
      if (preferred.images?.length) {
        return preferred;
      }
      fallback = preferred;
      enqueue(preferred._id || preferred.id);
    }
  } catch (error) {
    console.warn('[pet] No se pudieron obtener mascotas personales', error);
  }

  if (!assignedId) {
    try {
      const { items } = await listMyAdoptions();
      const adopted = (items || []).find((item: any) => {
        const status = String(item?.status || '').toLowerCase();
        // Estados reales de AdoptionStatus: solo 'aprobada' significa que el animal
        // ya es del adoptante (antes se comparaba con 'accepted'/'active', vocabulario
        // del legado de alquiler que nunca casaba → la mascota adoptada no salía).
        return status === 'aprobada' && (item?.animal?._id || item?.animalId);
      });
      if (adopted) {
        if (adopted.animal?.images?.length) {
          return adopted.animal;
        }
        if (adopted.animal) fallback = fallback || adopted.animal;
        enqueue(adopted.animal?._id || adopted.animalId);
      }
    } catch (error) {
      console.warn('[pet] No se pudieron obtener adopciones del usuario', error);
    }
  }

  const detailed = await loadDetailed();
  if (detailed) return detailed;
  if (fallback) return fallback;

  // Sin mascota personal ni adopción no hay animal destacado: el UI muestra un
  // estado vacío honesto en vez de un placeholder de demo ("Popeye").
  return null;
}
